var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M306.5 1438.4 259 1789l350.6-47.5 1.2-1.2-303.1-303.1zM373.289 1371.649 1485.911 259.027l303.134 303.134L676.423 1674.783z"
})));
export default SvgEdit;